export default __webpack_public_path__ + "static/4-6df475e9a80b431cf947855d0b1d0192.png";